module.exports = __webpack_public_path__ + "static/media/TirzepatideAd.03502f64.png";